"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OxidizingagentCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var OxidizingagentCircleFilled = function OxidizingagentCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 13.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25h-6.5a.25.25 0 01-.25-.25v-.5a.25.25 0 01.25-.25h6.5zM8 7.5a3 3 0 110 6 3 3 0 010-6zm0 1a2 2 0 100 4 2 2 0 000-4zm1.364-6.977c.083.036.136.108.136.186 0 .972.588 1.632 1.269 2.395.735.825 1.568 1.76 1.705 3.25 0 0 .026.292.026.396 0 .679-.218 1.316-.598 1.866a4.001 4.001 0 00-7.804 0 3.263 3.263 0 01-.593-2.079C3.58 5.41 4.837 4.876 4.891 4.854a.294.294 0 01.226.004c.07.031.12.089.13.154.003.014.234 1.285 1.253 1.467.005-.548.034-1.376.258-2.113C7.079 3.307 8 2.198 9.104 1.539a.29.29 0 01.26-.016z",
    fill: "currentColor"
  }));
};

exports.OxidizingagentCircleFilled = OxidizingagentCircleFilled;
var _default = OxidizingagentCircleFilled;
exports.default = _default;